import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { SiteProvider, useSite } from "@/context/SiteContext";
import { GoogleTranslateLoader } from "@/components/site/GoogleTranslate";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import FloatingButtons from "@/components/site/FloatingButtons";
import ScrollToTop from "@/components/site/ScrollToTop";
import Home from "@/pages/Home";
import ToursPage from "@/pages/ToursPage";
import TourDetail from "@/pages/TourDetail";
import CartPage from "@/pages/CartPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function PublicLayout() {
  const { theme } = useSite();
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    return () => document.documentElement.classList.remove("dark");
  }, [theme]);
  return (
    <div className="site-root min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/excursiones" element={<ToursPage />} />
              <Route path="/excursion/:id" element={<TourDetail />} />
              <Route path="/carrito" element={<CartPage />} />
              <Route path="/pago/exito" element={<PaymentSuccess />} />
              <Route path="/pago/cancelado" element={<PaymentCancel />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        <GoogleTranslateLoader />
      </SiteProvider>
    </div>
  );
}

export default App;
